<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="save">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-row style="display: block; margin-left: 10%; margin-right: 10%; margin-top: 15px">
          <v-text-field
            v-model="phoneNumber"
            label="Номер телефона"
            prepend-inner-icon="mdi-phone"
            type="phone"
            class=""
            outlined
            dense
            flat
            required
            @input="handlePhoneInput"
            :rules="[
              v => !!v || 'Поле обязательное для заполнения',
            ]"
            :maxlength="phoneNumber.startsWith('+7') ? 16 : null"
          ></v-text-field>
          <v-text-field
            v-model="fullName"
            label="Имя"
            prepend-inner-icon="mdi-rename"
            class=""
            outlined
            dense
            flat
          ></v-text-field>
          <v-text-field
            v-model="address"
            label="Адрес"
            prepend-inner-icon="mdi-map-marker"
            class=""
            outlined
            dense
            flat
          ></v-text-field>
          <v-text-field
            v-model="apartment"
            label="Квартира"
            prepend-inner-icon="mdi-door"
            class=""
            outlined
            dense
            flat
          ></v-text-field>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="190px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRange"
                label="Промежуток действия номера"
                outlined
                dense
                hide-details
                class="input input-search mb-4"
                v-on="on"
                prepend-inner-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" @click="menu = false" range :min="minDate" :max="maxDate">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Назад
              </v-btn>
              <v-btn text color="primary" :disabled="!date[0]" @click="date = []">
                Сбросить
              </v-btn>
              <v-btn text color="primary" @click="menu = false">
                Выбрать
              </v-btn>
            </v-date-picker>
          </v-menu>
          <div style="display: block; text-align: center;">
            <v-btn
              outlined
              class="text-none mb-2 px-2 btn-code"
              rounded
              dark
              :disabled="!valid"
              @click="save"
            >
              Сохранить
            </v-btn>
          </div>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify; font-family: Arial, sans-serif;">
              <p>
                <strong>Здесь вы можете создать номер в белом списке для шлагбаума.</strong>
              </p>
              <p>
                <br>Номер в белом списке позволяет открывать шлагбаум по звонку с указанного телефона.
                <br>Вы можете указать имя, адрес и квартиру для удобства идентификации.
              </p>
              <p>
                <br>Вы можете указать промежуток времени действия номера. Если временной интервал будет указан,
                номер будет действовать только в указанный промежуток времени.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formatPhoneNumberTextField from '@/mixins/formatPhoneNumberTextField';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  mixins: [formatPhoneNumberTextField, ruDateFormatMixin],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    editingItem: {
      type: Object,
      default: null,
    },
    message: {
      type: String,
      default: 'Новый номер в белом списке',
    },
    icon: {
      type: String,
      default: 'mdi-phone-check',
    },
  },
  data () {
    const today = new Date();
    const max = new Date();
    max.setMonth(today.getMonth() + 1);

    return {
      valid: true,
      isDisplaySmall: false,
      phoneNumber: '',
      fullName: '',
      address: '',
      apartment: '',
      date: [],
      menu: false,
      minDate: today.toISOString().substr(0, 10),
      maxDate: max.toISOString().substr(0, 10),
    };
  },
  computed: {
    dateRange () {
      const startDate = this.date && this.date[0] ? this.ruDateFormat(this.date[0], true) : '';
      const endDate = this.date && this.date[1] ? this.ruDateFormat(this.date[1], true) : '';

      if (startDate && endDate) {
        return `${startDate} - ${endDate}`;
      } else if (startDate) {
        return startDate;
      } else if (endDate) {
        return endDate;
      }
      return '';
    },
  },
  watch: {
    active (newVal) {
      if (newVal) {
        if (this.editingItem) {
          this.phoneNumber = this.editingItem.phone_number || '';
          this.fullName = this.editingItem.full_name || '';
          this.address = this.editingItem.address || '';
          this.apartment = this.editingItem.apartment || '';
          const validFrom = this.editingItem.valid_from ? this.editingItem.valid_from.split(' ')[0] : '';
          const validUntil = this.editingItem.valid_until ? this.editingItem.valid_until.split(' ')[0] : '';
          this.date = validFrom && validUntil ? [validFrom, validUntil] : validFrom ? [validFrom] : [];
        } else {
          this.resetForm();
        }
      }
    },
    editingItem: {
      immediate: true,
      handler (newVal) {
        if (newVal && this.active) {
          this.phoneNumber = newVal.phone_number || '';
          this.fullName = newVal.full_name || '';
          this.address = newVal.address || '';
          this.apartment = newVal.apartment || '';
          const validFrom = newVal.valid_from ? newVal.valid_from.split(' ')[0] : '';
          const validUntil = newVal.valid_until ? newVal.valid_until.split(' ')[0] : '';
          this.date = validFrom && validUntil ? [validFrom, validUntil] : validFrom ? [validFrom] : [];
        }
      },
    },
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkSize);
  },
  methods: {
    handlePhoneInput (event) {
      this.phoneNumber = this.formatPhoneNumberTextField(event);
    },
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    resetForm () {
      this.phoneNumber = '';
      this.fullName = '';
      this.address = '';
      this.apartment = '';
      this.date = [];
    },
    async save () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          const phoneNumberToSend = this.phoneNumber.replace(/\D/g, '');

          const validFrom = this.date && this.date[0] ? this.date[0] : null;
          const validUntil = this.date && this.date[1] ? this.date[1] : null;

          this.$emit(
            'save',
            phoneNumberToSend,
            this.fullName || null,
            this.address || null,
            this.apartment || null,
            validFrom,
            validUntil,
          );
        }
      });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.resetForm();
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 71px;
  max-height: 71px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.border {
  border-radius: 16px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
</style>
